// textRestriction.js
const inputTextLimit = 250;
const inputDescLimit = 10000;
const editProfileLimit = 25;
// Regex to detect possible XSS and SQL Injection patterns in input
const maliciousPattern =
  /(<[^>]+>)|(<\/?script\b[^>]*>)|(on\w+=["'][^"']*["'])|(<iframe\b[^>]*>)|(\beval\()|(\balert\()|(--|\/\*.*?\*\/)|(\b(union\s+select|select\b.*?\bfrom|insert\s+into|delete\s+from|drop\s+table|update\b.*?\bset)\b)/i;
const maliciousPatternForEditor =
  /(<\/?script\b[^>]*>)|(on\w+=["'][^"']*["'])|(<iframe\b[^>]*>)|(\beval\()|(\balert\()|(--|\/\*.*?\*\/)|(\b(union\s+select|select\b.*?\bfrom|insert\s+into|delete\s+from|drop\s+table|update\b.*?\bset)\b)/i;

const containsMaliciousForEditor = (text) => {
  if (!text) return false;
  return maliciousPatternForEditor.test(text);
};
// Function to check if text contains malicious patterns
const containsMalicious = (text) => {
  if (!text) return false;
  return maliciousPattern.test(text);
};

// Strong password regex: min 8 chars, at least 1 uppercase, 1 lowercase, 1 digit, 1 special char (!@#$%^&*)
const strongPasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[a-zA-Z\d!@#$%^&*]{8,}$/;

// Corrected function (your original one had a reference to 'values.password' which doesn't exist here)
const strongPassword = (password) => {
  if (!password) return false;
  return strongPasswordRegex.test(password); // Return true if password is strong
};
export {
  inputTextLimit,
  inputDescLimit,
  editProfileLimit,
  containsMalicious,
  strongPassword,
  containsMaliciousForEditor,
};

export function cleanInput(value) {
  return value
    .replace(/[\u0000-\u001F\u007F-\u009F\u200B-\u200F\uFEFF]/g, "") // Remove control and zero-width chars
    .replace(/\s+/g, " ") // Normalize whitespace
    .trim();
}
